import * as React from 'react';
import { compose, withState, withHandlers } from 'recompose';
import { withUser } from '../../helpers/withUser';
import { StyledBox, ProfilePane, ProfileBoxLinks } from '../../components/UI/ProfileBoxUI';
import { withLogout } from '../../helpers/withLogout';
import { NavLink } from 'react-router-dom';
import Routes from '../../constants/Routes';

type Props = {
  user: {
    authId: string;
    loggedIn: boolean;
    email: string;
    phone: string;
  };
  active?: boolean;
  logout?: () => void;
  togglePane: () => void;
};

const ProfileEmpty = () => (
  <ProfileBoxLinks>
    <NavLink to={Routes.login}>Login</NavLink>
    <NavLink to={Routes.signup}>Sign Up</NavLink>
  </ProfileBoxLinks>
);

const Profile: React.SFC<Props> = ({ user, togglePane }) => (
  <ProfileBoxLinks>
    <a href="" onClick={togglePane}>
      {user.email}
    </a>
  </ProfileBoxLinks>
);

const ProfileBox: React.SFC<Props> = ({ user, active, logout, togglePane }) => (
  <StyledBox>
    {user && user.loggedIn ? <Profile user={user} togglePane={togglePane} /> : <ProfileEmpty />}
    {active && (
      <ProfilePane>
        <div>Profile Pane</div>
        <NavLink to={Routes.settings}>Settings</NavLink>
        <br />
        <a href="#" onClick={logout}>
          Sign out
        </a>
      </ProfilePane>
    )}
  </StyledBox>
);

const enhance = compose(
  withUser,
  withLogout,
  withState('active', 'setActive', false),
  withHandlers({
    togglePane: ({ setActive, active }) => (event: any) => {
      event.preventDefault();
      setActive(!active);
    },
  }),
);

export default enhance(ProfileBox);



// WEBPACK FOOTER //
// ./src/containers/Site/ProfileBox.tsx